import $ from 'jquery';
import mixitup from 'mixitup';

$(function () {
	const $mixitContainer = $('.js-mixit');

	if ($mixitContainer.length) {
		mixitup($mixitContainer);
	}
});



// WEBPACK FOOTER //
// ./app/blocks/portfolio/portfolio.js